/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductClassificationGenericProductsQueryVariables = Exact<{
  subFamilyCode: string;
}>;


export type ProductClassificationGenericProductsQuery = { product_classification_node: Array<{ code: string, parent_code: string | null }> };


export const ProductClassificationGenericProductsDocument = /*#__PURE__*/ gql`
    query ProductClassificationGenericProducts($subFamilyCode: String!) {
  product_classification_node(
    where: {level: {_eq: GENERIC_PRODUCT}, parent: {parent_code: {_eq: $subFamilyCode}}}
    order_by: {code: asc}
  ) {
    code
    parent_code
  }
}
    `;

/**
 * __useProductClassificationGenericProductsQuery__
 *
 * To run a query within a React component, call `useProductClassificationGenericProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductClassificationGenericProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductClassificationGenericProductsQuery({
 *   variables: {
 *      subFamilyCode: // value for 'subFamilyCode'
 *   },
 * });
 */
export function useProductClassificationGenericProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables> & ({ variables: ProductClassificationGenericProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables>(ProductClassificationGenericProductsDocument, options);
      }
export function useProductClassificationGenericProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables>(ProductClassificationGenericProductsDocument, options);
        }
// @ts-ignore
export function useProductClassificationGenericProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables>;
export function useProductClassificationGenericProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductClassificationGenericProductsQuery | undefined, ProductClassificationGenericProductsQueryVariables>;
export function useProductClassificationGenericProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables>(ProductClassificationGenericProductsDocument, options);
        }
export type ProductClassificationGenericProductsQueryHookResult = ReturnType<typeof useProductClassificationGenericProductsQuery>;
export type ProductClassificationGenericProductsLazyQueryHookResult = ReturnType<typeof useProductClassificationGenericProductsLazyQuery>;
export type ProductClassificationGenericProductsSuspenseQueryHookResult = ReturnType<typeof useProductClassificationGenericProductsSuspenseQuery>;
export type ProductClassificationGenericProductsQueryResult = Apollo.QueryResult<ProductClassificationGenericProductsQuery, ProductClassificationGenericProductsQueryVariables>;